import React from "react";
import { WebAlertLogEntry } from "./NotificationModal";
import { IsUnreadTr } from "./styles";

interface WebAlertsLogItemProps {
    log: WebAlertLogEntry;
    onToggle: () => void;
    formatDateTime: (date: string) => string;
    // onRead: (id: number) => void;
    isUnreadWebAlertsLogs: boolean;
}

const WebAlertLogItem: React.FC<WebAlertsLogItemProps> = ({
    log,
    onToggle,
    formatDateTime,
    isUnreadWebAlertsLogs,
}) => {
    return (
        <>
            <IsUnreadTr
                onClick={onToggle}
                style={{ cursor: "auto" }}
                $isUnread={isUnreadWebAlertsLogs}
            >
                <td style={{ width: "130px" }}>
                    {formatDateTime(log.created_at)}
                </td>
                <td>
                    <span
                        style={{
                            color:
                                log.level.toLowerCase() === "error"
                                    ? "red"
                                    : log.level.toLowerCase() === "warning"
                                    ? "orange"
                                    : "green",
                            fontWeight: "bold",
                        }}
                    >
                        {log.level}
                    </span>
                </td>
                <td
                    style={{
                        maxWidth: "400px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        lineHeight: "1.4",
                    }}
                >
                    {log.text}
                </td>
            </IsUnreadTr>
        </>
    );
};

export default WebAlertLogItem;
